import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

const NHS_LINK_STATE_KEY = 'nhs_link_state';

/** OAuth state from the NHS mismatch callback — required for /login/nhs. */
export function readNhsLinkState(): string | null {
  try {
    const direct = localStorage.getItem(NHS_LINK_STATE_KEY);
    if (direct && direct.trim() !== '') {
      return direct.trim();
    }
    const callback = localStorage.getItem('nhs_callback_state');
    if (callback && callback.trim() !== '') {
      return callback.trim();
    }
  } catch {
    /* storage unavailable */
  }
  return null;
}

export function persistNhsLinkState(state: string): void {
  const trimmed = state.trim();
  if (!trimmed) {
    return;
  }
  try {
    localStorage.setItem(NHS_LINK_STATE_KEY, trimmed);
    localStorage.setItem('nhs_callback_state', trimmed);
  } catch {
    /* storage unavailable */
  }
}

export function clearNhsLinkState(): void {
  try {
    localStorage.removeItem(NHS_LINK_STATE_KEY);
    localStorage.removeItem('nhs_callback_state');
    localStorage.removeItem('nhs_email_on_account');
  } catch {
    /* storage unavailable */
  }
}

/**
 * Allows /login/nhs only while the NHS callback left a live OAuth state in storage.
 */
export const nhsLinkStateGuard: CanActivateFn = () => {
  const router = inject(Router);
  if (readNhsLinkState()) {
    return true;
  }
  return router.parseUrl('/login');
};
